const UAuth = () => (
    <svg
        width='40'
        height='40'
        viewBox='-2 -3 30 30'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        id='uauth'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M23 2.34473V9.93093L1 18.8965L23 2.34473Z'
            fill='#FFF'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M18.875 2V15.1034C18.875 18.9123 15.797 22 12 22C8.20304 22 5.125 18.9123 5.125 15.1034V9.58621L9.25 7.31034V15.1034C9.25 16.4365 10.3273 17.5172 11.6562 17.5172C12.9852 17.5172 14.0625 16.4365 14.0625 15.1034V4.65517L18.875 2Z'
            fill='white'
        />
    </svg>
);

export default UAuth;
